/* And Beyond, Darn Tough build.
   Collection filtering runs client side because Shopify Liquid cannot read
   arbitrary query params, and native filters would need the Search and
   Discovery app installed. All products render, JS hides the rest.
   NOTE: keep every expression on ONE line. A trailing-operator line
   continuation gets turned into a literal backslash-n by the upload path,
   which breaks the file. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var KEYS = ['gender', 'height', 'colour'];

  function val(c, k) {
    if (k === 'gender') { return c.dataset.gender; }
    if (k === 'height') { return c.dataset.height; }
    return c.dataset.colour;
  }

  function initCollection(root) {
    var cards = $$('[data-ab-card]', root);
    if (!cards.length) { return; }
    if (!$('[data-ab-filter]', root)) { return; }

    var state = { gender: [], height: [], colour: [] };
    var q = new URLSearchParams(location.search);
    KEYS.forEach(function (k) {
      var v = q.get(k);
      if (v) { state[k] = v.split(',').map(function (s) { return s.trim(); }).filter(Boolean); }
    });

    var boxes = $$('[data-ab-filter]', root);
    boxes.forEach(function (b) {
      b.checked = state[b.dataset.abFilter].indexOf(b.value) > -1;
      b.addEventListener('change', function () {
        var set = state[b.dataset.abFilter];
        var i = set.indexOf(b.value);
        if (b.checked && i < 0) { set.push(b.value); }
        if (!b.checked && i > -1) { set.splice(i, 1); }
        paint();
      });
    });

    function passes(c, skip) {
      return KEYS.every(function (k) {
        if (k === skip) { return true; }
        if (!state[k].length) { return true; }
        return state[k].indexOf(val(c, k)) > -1;
      });
    }

    function paint() {
      var n = 0;
      cards.forEach(function (c) {
        var ok = passes(c, null);
        c.hidden = !ok;
        if (ok) { n++; }
      });

      var count = $('[data-ab-count]', root);
      if (count) { count.textContent = n + (n === 1 ? ' product' : ' products'); }
      var empty = $('[data-ab-empty]', root);
      if (empty) { empty.hidden = n > 0; }

      $$('[data-ab-n]', root).forEach(function (em) {
        var p = em.dataset.abN.split(':');
        var k = p[0];
        var v = p.slice(1).join(':');
        var c = cards.filter(function (card) { return passes(card, k) && val(card, k) === v; }).length;
        em.textContent = c;
        var row = em.closest('.fopt');
        if (row) { row.style.opacity = c ? '' : '.4'; }
      });

      var chips = $('[data-ab-chips]', root);
      if (chips) {
        var all = [];
        KEYS.forEach(function (k) { state[k].forEach(function (v) { all.push({ k: k, v: v }); }); });
        var html = '';
        all.forEach(function (c) {
          html += '<span class="chip">' + c.v + '<button type="button" data-ab-clear="' + c.k + '" data-v="' + c.v + '" aria-label="Remove ' + c.v + '">&times;</button></span>';
        });
        if (all.length) { html += '<button class="chip" data-ab-clear="*" style="border-style:dashed">Clear all</button>'; }
        chips.innerHTML = html;
      }

      var u = new URL(location.href);
      KEYS.forEach(function (k) {
        u.searchParams.delete(k);
        if (state[k].length) { u.searchParams.set(k, state[k].join(',')); }
      });
      history.replaceState(null, '', u);
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ab-clear]');
      if (!b) { return; }
      if (b.dataset.abClear === '*') { state.gender = []; state.height = []; state.colour = []; }
      else {
        var set = state[b.dataset.abClear];
        var i = set.indexOf(b.dataset.v);
        if (i > -1) { set.splice(i, 1); }
      }
      boxes.forEach(function (x) { x.checked = state[x.dataset.abFilter].indexOf(x.value) > -1; });
      paint();
    });

    var sort = $('[data-ab-sort]', root);
    if (sort) {
      sort.addEventListener('change', function () {
        var grid = cards[0].parentNode;
        var arr = cards.slice();
        var v = sort.value;
        arr.sort(function (a, b) {
          if (v === 'az') { return a.dataset.title.localeCompare(b.dataset.title); }
          if (v === 'za') { return b.dataset.title.localeCompare(a.dataset.title); }
          if (v === 'height') { return a.dataset.height.localeCompare(b.dataset.height) || a.dataset.colour.localeCompare(b.dataset.colour); }
          return a.dataset.i - b.dataset.i;
        });
        arr.forEach(function (c) { grid.appendChild(c); });
      });
    }

    paint();
  }

  function initProduct(root) {
    var main = $('[data-ab-main]', root);
    if (!main) { return; }
    $$('[data-ab-thumb]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-ab-thumb]', root).forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        main.src = b.dataset.abThumb;
      });
    });

    var idInput = $('[data-ab-variant]', root);
    var addBtn = $('[data-ab-add]', root);
    $$('[data-ab-size]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) { return; }
        $$('[data-ab-size]', root).forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        if (idInput) { idInput.value = b.dataset.abSize; }
        if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'Add to bag'; }
      });
    });
  }

  /* Cart. Explicit fetch to /cart/add.js rather than a native form post,
     because the theme's own cart JS intercepts forms whose action contains
     /cart/add and serialises them without the submit button, which silently
     drops the variant id. */
  function addToCart(id) {
    var opts = { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) };
    return fetch('/cart/add.js', opts).then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw new Error(e.description || 'Add failed'); }); });
  }

  function refreshCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var sel = '[data-cart-count], .cart-count, .header__cart-count, [data-header-cart-count], .cart-link__bubble-num';
      $$(sel).forEach(function (el) { el.textContent = c.item_count; });
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: c }, bubbles: true }));
    }).catch(function () {});
  }

  function initCart(root) {
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ab-quickadd]');
      if (!b || b.disabled) { return; }
      e.preventDefault();
      var label = b.textContent;
      b.disabled = true;
      b.textContent = '...';
      addToCart(b.dataset.abQuickadd).then(function () {
        b.textContent = 'Added';
        refreshCount();
        setTimeout(function () { b.textContent = label; b.disabled = false; }, 1400);
      }).catch(function () {
        b.textContent = 'Sorry';
        setTimeout(function () { b.textContent = label; b.disabled = false; }, 1800);
      });
    });

    var form = $('[data-ab-pdp-form]', root);
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var idInput = $('[data-ab-variant]', root);
        var btn = $('[data-ab-add]', root);
        if (!idInput || !idInput.value) { return; }
        btn.disabled = true;
        btn.textContent = 'Adding...';
        addToCart(idInput.value).then(function () { location.href = '/cart'; }).catch(function () {
          btn.textContent = 'Sorry, try again';
          btn.disabled = false;
        });
      });
    }
  }

  function boot() {
    $$('.abdt').forEach(function (root) { initCollection(root); initProduct(root); initCart(root); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
})();